// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__zxsSt","leftIcon":"MGInput_leftIcon__wL6PF","rightIcon":"MGInput_rightIcon__hr7ES","rightIconButton":"MGInput_rightIconButton__hM1aL"};